<template>
    <div class="content-box">
        <el-card class="box-card">
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="指令名称 : ">
                    <el-input v-model="formInline.instrustName" size="mini" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="请求地址(0X) : ">
                    <el-input v-model="formInline.frameId" size="mini" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="所属车型 : ">
                    <el-select v-model="formInline.vehicleType" placeholder="请选择" size="mini">
                        <el-option
                                v-for="item in carOptions"
                                :key="item.vehicleTypeCode"
                                :label="item.vehicleTypeName"
                                :value="item.vehicleTypeCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button @click="searchTableData(1)" type="primary" size="mini">查询</el-button>
                    <el-button @click="searchTableData(2)" size="mini">重置</el-button>
                </el-form-item>
            </el-form>
            <div style="margin-bottom: 20px">
                <el-button @click="openDrawer(1)" size="mini">新增</el-button>
                <el-button @click="openDrawer(2)" size="mini">修改</el-button>
                <el-popconfirm
                        style="padding: 10px"
                        title="确定将选择数据删除？"
                        @confirm="deleteItems"
                >
                    <el-button :loading="deleteType" size="mini" slot="reference">删除</el-button>
                </el-popconfirm>
                <el-button @click="downloadModal" size="mini">下载模板</el-button>
                <el-upload
                        class="upload-demo"
                        action="#"
                        :http-request="uploadFile"
                        :show-file-list="false"
                        style="display:inline-block;padding: 0 10px"
                        ref="upload"
                >
                    <el-button id="imgInput" size="mini">导入</el-button>
                </el-upload>
                <el-button @click="downloadFile" size="mini">导出</el-button>
            </div>
            <el-table
                    row-key="id"
                    v-loading="tableLoadingType"
                    class="tableListValue"
                    :height="tableHeight"
                    ref="table"
                    :data="tableData"
                    stripe
                    style="width: 100%">
                <el-table-column
                        :reserve-selection="true"
                        align="center"
                        type="selection"
                        width="50">
                </el-table-column>
                <el-table-column label="序号" type="index" width="60" align="center">
                    <template #default="scope">
                        <span v-text="getIndex(scope.$index)"></span>
                    </template>
                </el-table-column>
                <el-table-column
                        min-width="120"
                        prop="instrustName"
                        align="center"
                        label="指令名称">
                </el-table-column>
                <el-table-column
                        min-width="120"
                        prop="instrustDesc"
                        align="center"
                        label="指令描述">
                </el-table-column>
                <el-table-column
                        width="120"
                        prop="canChannel"
                        align="center"
                        label="通道">
                    <template slot-scope="scope">
                        {{ scope.row.canChannel==='0'?'通道0':scope.row.canChannel==='1'?'通道1': '-'}}
                    </template>
                </el-table-column>
                <el-table-column
                        width="120"
                        prop="addressType"
                        align="center"
                        label="地址类型">
                    <template slot-scope="scope">
                        {{ scope.row.addressType==='0'?'物理地址':scope.row.addressType==='1'?'功能地址': '-'}}
                    </template>
                </el-table-column>
                <el-table-column
                        width="120"
                        prop="frameId"
                        align="center"
                        label="请求地址(0X)">
                </el-table-column>
                <el-table-column
                        width="120"
                        prop="receiveAddress"
                        align="center"
                        label="响应地址(0X)">
                    <template slot-scope="scope">
                        {{ scope.row.receiveAddress || '-' }}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="instructLength"
                        align="center"
                        label="长度">
                </el-table-column>
                <el-table-column
                        prop="instructContent"
                        align="center"
                        min-width="120"
                        label="数据">
                </el-table-column>
                <el-table-column
                        prop="frameType"
                        align="center"
                        label="帧类型">
                    <template slot-scope="scope">
                        {{ scope.row.frameType==0?'标准帧':scope.row.frameType==1?'拓展帧':'暂无' }}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="vehicleTypeName"
                        align="center"
                        min-width="120"
                        label="所属车型">
                    <template slot-scope="scope">
                        {{ scope.row.vehicleTypeName || '-' }}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="creator"
                        align="center"
                        label="创建账号">
                </el-table-column>
                <el-table-column
                        min-width="150"
                        prop="createTime"
                        align="center"
                        label="创建时间">
                </el-table-column>
                <el-table-column
                        min-width="150"
                        prop="modifTime"
                        align="center"
                        label="修改时间">
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </el-card>
        <!--    新增修改弹框-->
        <el-drawer
                :destroy-on-close="true"
                :show-close="false"
                :title="drawerTitle"
                :visible.sync="drawerType"
                direction="rtl"
                size="30%">
            <CommandDialog :drawerForm="drawerForm" :dialogType="dialogType"
                                   @drawerClose="drawerClose"></CommandDialog>
        </el-drawer>
    </div>
</template>

<script>
    import {getDatavehicleTypeList} from "../../common/carModelApi";
    import {getDataInstructList,downloadModal,uploadExcel,download,delDataInstructs} from "../../common/command"
    import CommandDialog from "./components/commandDialog";
    import {exportFile} from "../../utils/utils";
    // import {getDatavehicleList} from "../../common/experimentCarApi";

    export default {
        name: "commandConfiguration",
        components: {
            CommandDialog
        },
        data() {
            return {
                formInline: {},
                carOptions: [],
                currentPage: 1,
                pageSize: 10,
                total: 0,
                tableLoadingType: false,
                dialogType: 0,
                drawerForm: {},
                tableHeight: 0,
                tableData: [],
                drawerTitle: '',
                drawerType: false,
                deleteType: false,
            }
        },
        mounted() {
            this.$nextTick(function () {
                this.tableHeight =
                    window.innerHeight - this.$refs.table.$el.offsetTop - 85
            })
            this.getDataInstructList()
            this.getDatavehicleTypeList()
        },
        methods: {
            // 导出文件
            async downloadFile() {
                const arr = this.$refs.table.selection;
                console.log(arr)
                if (arr.length === 0) {
                    this.$notify.error({
                        title: '操作错误 !',
                        message: '请选择数据后操作 !'
                    })
                    return
                }
                const ids = []
                for (const el of arr.values()) {
                    ids.push(el.id)
                }
                await download({ids}).then(res=>{
                    console.log(res)
                    let fileNames = res.headers['content-disposition'] //获取到Content-Disposition;filename
                    let regFileNames = fileNames.match(/=(.*)$/)[1]; //文件名称  截取=后面的文件名称
                    if (res.data) {
                        exportFile(res.data, decodeURI(regFileNames,'utf-8'))
                        this.$refs.table.clearSelection();
                    } else {
                        this.$notify.error({
                            title: '错误提示',
                            message: '导出数据失败 !'
                        })
                    }
                }).catch(err=>{
                    console.log(err)
                })
            },
            // 导入数据
            async uploadFile(file) {
                try {
                    const param = new FormData()
                    param.append('file', file.file)
                    const res = await uploadExcel(param)
                    if (res.code === 200) {
                        this.$notify.success({
                            title: '成功提示',
                            message: '导入成功'
                        })
                        this.getDataInstructList()
                    } else {
                        this.$notify.error({
                            title: '错误提示',
                            message: res.msg,
                            dangerouslyUseHTMLString: true
                        })
                    }
                } catch (e) {
                    console.log(e)
                }
            },
            // 下载模板
            async downloadModal() {
                const data = await downloadModal()
                console.log(data)
                if (!data.headers) {
                    this.$notify.error({
                        title: '错误提示',
                        message: '导出数据失败 !'
                    })
                } else {
                    let fileNames = data.headers['content-disposition'] //获取到Content-Disposition;filename
                    let regFileNames = fileNames.match(/=(.*)$/)[1]; //文件名称  截取=后面的文件名称
                    exportFile(data.data, decodeURI(regFileNames,'utf-8'))
                    this.$refs.table.clearSelection();
                }
            },
            // 删除列表数据
            async deleteItems() {
                const arr = this.$refs.table.selection;
                if (arr.length === 0) {
                    this.$notify.error({
                        title: '操作错误 !',
                        message: '请选择数据后操作 !'
                    })
                    return
                }
                if (arr.length > 1) {
                    this.$notify.error({
                        title: '操作错误 !',
                        message: '只可选择一条数据后操作 !'
                    })
                    return
                }
                this.deleteType = true
                try {
                    const ids = []
                    for (const el of arr.values()) {
                        ids.push(el.id)
                    }
                    console.log(ids)
                    const res = await delDataInstructs({ids})
                    if (res.code === 200) {
                        this.$notify.success({
                            title: '成功提示',
                            message: '删除成功'
                        })
                        this.$refs.table.clearSelection();
                        this.deleteType = false
                        this.getDataInstructList()
                    } else {
                        this.$notify.error({
                            title: '错误提示',
                            message: res.msg
                        })
                        this.deleteType = false
                    }
                } catch (e) {
                    this.deleteType = false
                    console.log(e)
                }
            },
            // 新增修改弹框
            openDrawer(type) {
                this.dialogType = type
                if (type === 1) {
                    this.drawerTitle = '新增指令信息'
                    this.drawerForm = {}
                    this.drawerType = true
                } else {
                    const arr = this.$refs.table.selection;
                    if (arr.length === 0) {
                        this.$notify.error({
                            title: '操作错误 !',
                            message: '请选择数据后操作 !'
                        })
                        return
                    }
                    if (arr.length > 1) {
                        this.$notify.error({
                            title: '操作错误 !',
                            message: '只可选择一条数据后操作 !'
                        })
                        return
                    }
                    this.drawerForm = JSON.parse(JSON.stringify(arr[0]))
                    this.drawerForm.canChannel = JSON.parse(JSON.stringify(arr[0])).canChannel*1
                    console.log(this.drawerForm)
                    this.drawerTitle = '修改指令信息'
                    this.drawerType = true
                }
            },
            // 获取列表
            async getDataInstructList() {
                this.tableLoadingType = true
                try {
                    const param = {
                        pageNo: this.currentPage,
                        pageSize: this.pageSize,
                        frameId: this.formInline.frameId,
                        instrustName: this.formInline.instrustName,
                        vehicleType: this.formInline.vehicleType
                    }
                    const res = await getDataInstructList(param)
                    console.log(res)
                    if (res.code === 200) {
                        this.tableData = res.data
                        this.total = res.total
                        this.tableLoadingType = false
                    } else {
                        this.$notify.error({
                            title: '错误提示',
                            message: res.msg
                        });
                        this.tableLoadingType = false
                    }
                } catch (e) {
                    this.tableLoadingType = false
                    console.log(e)
                }
            },
            // 搜索重置
            searchTableData(type) {
                if (type === 2) {
                    this.formInline = {}
                }
                this.getDataInstructList()
            },
            // 关闭弹框
            drawerClose() {
                this.getDataInstructList()
                this.$refs.table.clearSelection();
                this.drawerType = false
            },
            getIndex(index) {
                return (this.currentPage - 1) * this.pageSize + index + 1
            },
            // 获取车型列表
            async getDatavehicleTypeList() {
                try {
                    const res = await getDatavehicleTypeList()
                    if (res.code === 200) {
                        this.carOptions = res.data
                    } else {
                        this.$notify.error({
                            title: '错误提示',
                            message: res.msg
                        });
                    }
                } catch (e) {
                    console.log(e)
                }
            },
            handleSizeChange(e) {
                // this.pageSize = e
                // this.getDatavehicleList()
            },
            handleCurrentChange(e) {
                // this.currentPage = e
                // this.getDatavehicleList()
            },
        }
    }
</script>

<style scoped>
    .pagination {
        margin-top: 10px;
        text-align: right;
    }

    .box-card {
        text-align: left;
        border-radius: 10px;
        height: 100%;
    }
</style>
<style scoped lang="scss">
    .tableListValue {
        //滚动条的宽高
        ::-webkit-scrollbar {
            width: 1vh;
            height: 1vh;
        }

        //滚动条的滑块背景色
        ::-webkit-scrollbar-thumb {
            background: #ccc;
            border-radius: 2vh;
        }

        //滚动条的背景色
        ::-webkit-scrollbar-track {
            background: rgba(#ccc, 0.3);
        }

    }


    /* 设置滚动条的样式 */
    /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/

    ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }


    /*定义滚动条轨道 内阴影+圆角*/

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
        border-radius: 4px;
        background-color: #F5F5F5;
    }


    /*定义滑块 内阴影+圆角*/

    ::-webkit-scrollbar-thumb {
        border-radius: 4px;
        -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
        background-color: #ccc;

    }

</style>
